import React, { CSSProperties, SyntheticEvent, useEffect, useMemo, useState } from "react";

import moment from "moment";
import { Calendar, DateLocalizer, View, momentLocalizer } from "react-big-calendar";

// UX
import CardSelectDateTimePackageUX from "./CardSelectDateTimePackageUX";
import ModMakeAppointmentPackage from "./ModMakeAppointmentPackage";

// Common
import SnackMessage from "react-lib/apps/common/SnackMessage";

// Interface
import {
  PackageBlockDetailType,
  RunSequence,
  SEQ_ACTIONS,
  State,
} from "./sequence/PackageDateTime";
import { DropdownProps, Icon, Loader, Modal } from "semantic-ui-react";
import { useIntl } from "react-intl";
import ModEventDetail from "react-lib/apps/Scheduling/ModEventDetail";
import { formatADtoBEString } from "react-lib/utils/dateUtils";
import { formatDoctorCount } from "react-lib/apps/Scheduling/SchedulingInterface";
import SearchBoxWithKey from "react-lib/appcon/common/SearchBoxWithKey";

// Types
type CardSelectDateTimePackageProps = {
  setProp: (key: string, value: any, callback?: Function) => any;
  onEvent: (e: any) => any;
  // data
  selectedPatient?: Record<string, any> | null;
  // controller
  proxyController?: any;
  // seq
  runSequence: RunSequence;
  PackageDateTimeSequence?: State["PackageDateTimeSequence"];
  // data
  allDivisionsOptions?: any[];
  // CommonInterface
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
  selectedDivision?: any;
  selectedAppointment?: Record<string, any> | null;
  searchedItemListWithKey?: any;
};

// Const
const localizer = momentLocalizer(moment);
const formats = {
  timeGutterFormat: (date: any, culture: any, localizer: any) =>
    localizer.format(date, "H:mm", culture),
  monthHeaderFormat: (date: Date, culture?: string, localize?: DateLocalizer) => {
    let defaultMonth = localize?.format(date, "MMMM YYYY", culture);
    let BEYear = Number(localize?.format(date, "YYYY")) + 543;
    let thaiMonth = localize?.format(date, "MMMM", "th-TH");
    return `${defaultMonth}  (${thaiMonth} ${BEYear})`;
  },
};

// const START_MONTH_DATE = moment().clone().add(-1, "months").startOf("months").toDate();

// const END_MONTH_DATE = moment().clone().add(1, "months").endOf("months").toDate();

export const CARD_SELECT_DATE_TIME_PACKAGE = "CardSelectDateTimePackage";

const CardSelectDateTimePackage = (props: CardSelectDateTimePackageProps) => {
  const intl = useIntl();

  const [showMod, setShowMod] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  const [selectedSlot, setSelectedSlot] = useState<PackageBlockDetailType | null>(null);
  const [selectedAppDivision, setSelectedAppDivision] = useState<number | null>(null);
  const [selectedProvider, setSelectedProvider] = useState<any>(null);
  const [blockFilterAppointments, setBlockFilterAppointments] = useState<any[]>([]);

  // Use Effect
  useEffect(() => {
    const divisionId = props.selectedDivision?.id;

    setSelectedAppDivision(divisionId);

    props.runSequence({
      sequence: "PackageDateTime",
      action: SEQ_ACTIONS.GET_DSB,
      division: divisionId,
      isRefresh: true,
    });
  }, []);

  useEffect(() => {
    const packageBlockList = props.PackageDateTimeSequence?.packageBlockList || [];

    const filterProvider = packageBlockList
      .map((item) => ({
        ...item,
        providers: (item.providers || [])?.filter((provider: any) => {
          const isMatched = selectedProvider
            ? provider.doctor_provider_id === selectedProvider
            : true;

          return isMatched && provider?.dsb?.doctor_dsb_status !== 2;
        }),
      }))
      .filter((item) => item.providers?.length !== 0);

    setBlockFilterAppointments(filterProvider);
  }, [props.PackageDateTimeSequence?.packageBlockList, selectedProvider]);

  const blockItems = useMemo(() => {
    return blockFilterAppointments.map((item) => {
      return {
        ...item,
        title: <DisplayTitle data={item} />,
      };
    });
  }, [blockFilterAppointments]);

  const selectedPackageItems = useMemo(() => {
    return props.PackageDateTimeSequence?.selectedPackageItems || [];
  }, [props.PackageDateTimeSequence?.selectedPackageItems]);

  const allDivisionsOptions = useMemo(() => {
    return (props.allDivisionsOptions || []).map((option) => ({ ...option, value: option.key }));
  }, [props.allDivisionsOptions]);

  const mapProviderOptions = (items: any[]) =>
    // console.log("mapProviderOptions items", items)
    items.map((item: any) => ({
      key: item.provider_id,
      text: `${item?.pre_name || ""} ${item.first_name} ${item.last_name} [${item.code}]`,
      value: item.provider_id,
    }));

  const handleCancel = () => {
    setSelectedSlot(null);
  };

  const handleSuccess = () => {
    setSelectedSlot(null);
    setSelectedEvent(null);
    setShowMod(false);
  };

  const handleSelectEvent = (event: any) => {
    const doctorCount = formatDoctorCount(event.providers);

    setSelectedEvent({
      ...event,
      date: moment(event.start).format("YYYY-MM-DD"),
      title: `${event.time} (แพทย์ ${doctorCount} คน)`,
    });
    setShowMod(true);
  };

  const handleChangeDivision = (e: SyntheticEvent, data: DropdownProps) => {
    setSelectedAppDivision(Number(data.value));

    props.runSequence({
      sequence: "PackageDateTime",
      action: SEQ_ACTIONS.GET_DSB,
      division: Number(data.value),
      isRefresh: true,
    });
  };

  const handleSelectProvider = (provider: Record<string, any>) => {
    const orderNote =
      props.selectedAppointment?.order_note ||
      props.PackageDateTimeSequence?.appointmentPackageDetail?.doctor_note ||
      "";

    setSelectedSlot({
      ...selectedEvent,
      doctor_note: orderNote,
      providers: selectedEvent.providers.filter(
        (item) => item.dsb.doctor_dsb_id === provider.doctor_dsb_id
      ),
    });
  };

  const handleNavigate = (date: Date) => {
    if (selectedAppDivision) {
      props.runSequence({
        sequence: "PackageDateTime",
        action: SEQ_ACTIONS.GET_DSB,
        date,
        division: selectedAppDivision,
      });
    }
  };

  console.log("CardSelectDateTimePackageUX", props);

  return (
    <div style={{ padding: "0.5rem 1rem" }}>
      <SnackMessage
        onEvent={props.onEvent}
        onClose={() => {
          props.setProp(`errorMessage.${CARD_SELECT_DATE_TIME_PACKAGE}`, null);
        }}
        error={props.errorMessage?.[CARD_SELECT_DATE_TIME_PACKAGE]}
        success={null}
        languageUX={props.languageUX}
      />

      <CardSelectDateTimePackageUX
        selectedAppDivision={selectedAppDivision}
        allDivisionsOptions={allDivisionsOptions}
        onChangeDivision={handleChangeDivision}
        doctorSearch={
          <SearchBoxWithKey
            onEvent={props.onEvent}
            id="SDTP"
            selectedItem={selectedProvider}
            type="Provider"
            width="100%"
            inline
            searchedItemListWithKey={props.searchedItemListWithKey}
            setSelected={(value: any) => {
              setSelectedProvider(value || null);
            }}
            mapOptions={mapProviderOptions}
          />
        }
        // Element
        Calendar={
          <div style={{ position: "relative" }}>
            {props.PackageDateTimeSequence?.blockLoadingFilter ? (
              <Loader style={{ left: "15.25rem", top: "1.05rem" }} size="mini" active />
            ) : null}
            <Calendar
              defaultView="month"
              localizer={localizer}
              events={blockItems}
              views={["day", "week", "month"]}
              startAccessor="start"
              endAccessor="end"
              formats={formats}
              style={{ height: "calc(100vh - 13rem)" }}
              selectable={true}
              tooltipAccessor={(event) => event.time + (event.count ? ` (${event.count})` : "")}
              eventPropGetter={(event: any, start: Date, end: Date, isSelected: boolean) => {
                const providers = event.providers ?? [];
                const doctorCount = providers.filter(
                  (item: any) =>
                    ["Doctor"].includes(item.dsb.doctor_provider_type) &&
                    item?.dsb?.doctor_dsb_status !== 2,
                ).length;

                return {
                  style: {
                    ...(doctorCount === 0
                      ? { backgroundColor: "#ffc0cb", color: "black" }
                      : ({} as CSSProperties)),
                    marginBottom: "1px",
                  },
                };
              }}
              onSelectEvent={handleSelectEvent}
              onRangeChange={(range: any, view?: View) => {
                // #console.log("onRangeChange", range, view);
              }}
              onNavigate={handleNavigate}
            />
          </div>
        }
        languageUX={props.languageUX}
      />

      <Modal
        open={!!selectedSlot}
        closeOnDimmerClick={true}
        style={{ width: "40%" }}
        onClose={handleCancel}
      >
        <ModMakeAppointmentPackage
          setProp={props.setProp}
          // controller
          proxyController={props.proxyController}
          // seq
          runSequence={props.runSequence}
          // data
          data={selectedSlot || {}}
          selectedPatient={props.selectedPatient}
          selectedPackageItems={selectedPackageItems}
          // CommonInterface
          selectedDivision={props.selectedDivision}
          buttonLoadCheck={props.buttonLoadCheck}
          // callback
          onCancel={handleCancel}
          onSuccess={handleSuccess}
          languageUX={props.languageUX}
        />
      </Modal>

      <Modal
        open={showMod}
        size="fullscreen"
        closeOnDimmerClick
        onClose={() => {
          setShowMod(false);
        }}
      >
        <ModEventDetail
          onEvent={props.onEvent}
          providers={selectedEvent?.providers}
          title={`วันที่เลือก: ${formatADtoBEString(selectedEvent?.date)}, ${selectedEvent?.title}`}
          hideExamType
          setShowMod={setShowMod}
          onSelect={handleSelectProvider}
        />
      </Modal>
    </div>
  );
};

/* ------------------------------------------------------ */

/*                      DisplayTitle;                     */

/* ------------------------------------------------------ */
const DisplayTitle = (props: any) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ fontSize: "0.75rem" }}>{props.data.time}</div>
      <div
        style={{
          display: "flex",
          fontSize: "0.65rem",
          marginTop: "0px",
          color: "#575656",
        }}
      >
        {!!props.data.count && (
          <>
            <Icon name="user" style={{ marginRight: 1 }} />
            <label style={{ margin: "0 5px", fontSize: "0.75rem" }}>{props.data.count}</label>
          </>
        )}
      </div>
    </div>
  );
};

CardSelectDateTimePackage.displayName = "CardSelectDateTimePackage";

export default React.memo(CardSelectDateTimePackage);
